import { createStandardAction } from 'typesafe-actions'
import { QuestionStatistics } from 'types/QuestionStatistics'
import { FirebaseError, UserInfo } from 'firebase'

export const setStatistics = createStandardAction('@firebase/statistics/set')<
  QuestionStatistics
>()

export const logIn = createStandardAction('@firebase/auth/login')()
export const logOut = createStandardAction('@firebase/auth/logout')()
export const authError = createStandardAction('@firebase/auth/error')<
  FirebaseError
>()
export const dbError = createStandardAction('@firebase/db/error')<
  FirebaseError
>()
